export interface ILabData {
    centerId: number,
    hasFrozenExploratory: boolean,
    hasFrozenScreening: boolean,
    xmVirtualOption: number,
    labLavender85: number,
    labLavender40: number,
    labLavender70: number,
    labLavender100: number,
    labPink60: number,
    labPink100: number,
    labRed70: number,
    labRed100: number,
    labGreen100: number,
    labYellow85: number,
    transLavender85: number,
    transLavender40: number,
    transLavender70: number,
    transLavender100: number,
    transPink60: number,
    transPink100: number,
    transRed70: number,
    transRed100: number,
    transGreen100: number,
    transYellow85: number
}